
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Channel } from "@/lib/types";

interface ChannelCardProps {
  channel: Channel;
  userRole: string;
  onEditChannel: (channelId: string) => void;
  onDeleteChannel: (channelId: string) => void;
}

export function ChannelCard({ 
  channel, 
  userRole, 
  onEditChannel, 
  onDeleteChannel 
}: ChannelCardProps) {
  return (
    <li className="flex items-center justify-between p-4 bg-muted rounded-md">
      <span>{channel.name}</span>
      <div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon">
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onEditChannel(channel.id)}>
              <Pencil className="h-4 w-4 mr-2" />
              Edit
            </DropdownMenuItem>
            {userRole === "admin" && (
              <DropdownMenuItem
                onClick={() => onDeleteChannel(channel.id)}
                className="text-destructive"
              >
                <Trash2 className="h-4 w-4 mr-2" />
                Delete
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </li>
  );
}
